import { kebabCase } from 'lodash';
import { WhatsAppSenderFields } from 'modules/graphql';
import { getWhatsAppSendLimitContent } from 'modules/sendingPlatforms/utils/text';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { formatPhoneNumber } from 'utils/phoneNumber';
import { Skeleton } from 'ui/skeleton';

import { BusinessProfilesOverflowMenu } from './BusinessProfilesOverflowMenu';
import { SenderIssueBanners } from './SenderIssueBanners';
import { Detail, Name, OverflowWrapper, Row, RowContent } from './WhatsAppChannelRow.styled';

type Props = { sender: WhatsAppSenderFields };

export const WhatsAppChannelRow = ({ sender }: Props) => {
  const { isWhatsAppGAEnabled } = useWhatsAppMessageChannelFeature();
  const { displayName, phoneNumber, qualityRating, sendLimit, status } = sender;

  return (
    <>
      <Row data-test={`whatsapp-channel-row-${kebabCase(displayName)}`}>
        <RowContent>
          {displayName ? (
            <Name>{displayName}</Name>
          ) : (
            <Skeleton isLoading height={20} width={200} />
          )}
          <Detail>
            {formatPhoneNumber(phoneNumber)}
            {isWhatsAppGAEnabled && !!displayName && (
              <>
                {' • '}
                <span data-test="whatsapp-sender-limit">
                  {getWhatsAppSendLimitContent(sendLimit, true, true)}
                </span>
                {' • '}
                <span data-test="whatsapp-sender-quality">{qualityRating} quality</span>
              </>
            )}
          </Detail>
        </RowContent>
        {!!displayName && (
          <OverflowWrapper>
            <BusinessProfilesOverflowMenu sender={sender} />
          </OverflowWrapper>
        )}
      </Row>
      <SenderIssueBanners sendLimit={sendLimit} status={status} />
    </>
  );
};
